import axios from './axiosConfig.js'

export const allFinancial = async () => {
  const response = await axios.get('/financial', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  // console.log('All financial companyData:', response.data)
  return response.data
}

export const getFinancialById = async (id) => {
  const response = await axios.get(`/financial/${id}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  console.log('financial response at api', response.data)
  return response.data
}

export const getCompanyWithId = async (id) => {
  const response = await axios.get(`/financial/company/${id}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  console.log('company response', response.data)
  return response.data
}

export const getSingleFinancialReportsById = async (id) => {
  const response = await axios.get(`/financial/single/report/${id}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  console.log('single report', response.data)
  return response.data
}

export const getFinancialReportsByYear = async (id, year) => {
  const response = await axios.get(`/financial/report/${id}/${year}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  console.log('report response', response.data)
  return response.data
}

export const updateCompany = async (id, formData) => {
  // console.log('Updating company with formdata:')

  // for (let [key, value] of formData.entries()) {
  //   console.log(`${key}:`, value)
  // }

  const response = await axios.put(`/financial/company/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  // console.log('Update company response:', response.data)
  return response.data
}

export const createFinancial = async (data, onProgress) => {
  try {
    const response = await axios.post('/financial', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          onProgress(percent)
        }
      },
    })

    return response.data
  } catch (error) {
    console.error('Error creating financial:', error)
    throw error
  }
}

export const updateFinancial = async (id, data) => {
  try {
    const response = await axios.put(`/financial/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error updating trending:', error)
    throw error
  }
}

export const getHideReportByCompanyId = async (id, year) => {
  const response = await axios.get(`/financial/hide/report/${id}/${year}`)
  console.log(response.data)
  return response.data
}

export const restoreReport = async (id) => {
  const response = await axios.put(`/financial/hide/report/${id}`)
  return response.data
}

export const restoreCompany = async (id) => {
  const response = await axios.put(`/financial/hide/company/${id}`)
  return response.data
}

export const getDeleteCompany = async () => {
  const response = await axios.get('/financial/hide/companies')
  console.log('getDeleteCompany:', response.data)
  return response.data
}

export const deleteReport = async (id, otp) => {
  try {
    const response = await axios.delete(`/financial/report/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete funding response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting funding:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/financial/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching funding:', error)
    throw error
  }
}

export const deleteCompany = async (id, otp) => {
  try {
    const response = await axios.delete(
      `/financial/companies/${id}?otp=${otp}`,
      {
        withCredentials: true,
      }
    )

    // console.log('Delete funding response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting funding:', error)
    throw error
  }
}

export const sendMailCompany = async (id) => {
  try {
    const response = await axios.get(`/financial/mail/company/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching funding:', error)
    throw error
  }
}
